import * as fromTypes from "../actions/types";
import uuid from "uuid";

const initialState = {
    id: uuid.v4(),
    siteId: "",
    location: "",
    inspector: "",
    date: new Date().toISOString().substring(0, 10),
    time: new Date().toTimeString().substring(0, 5),
    
    // Site Control
    hazardBoardSignage: false,
    environmentalPlanIssues: false,
    toolboxTalk: false,
    toolboxTalkDate: "",
    safetyInductions: false,
    safetyNoticeBoard: false,
    
    // Site Facilities
    officesClean: false,
    smokoShedsClean: false,
    toiletsClean: false,
    toolEquipmentShedsAdequate: false,
    
    // General Site Tidiness & Access Ways
    clearSafeAccess: false,
    stairwaysAccessWaysClear: false,
    hoardingsFenceSecure: false,
    looseMaterialsSecure: false,
    
    // Personal Safety Equipment
    signageDisplayedLegible: false,
    hardhatsWorn: false,
    correctFootwear: false,
    glassesEarMuffsVestsMasks: false,
    
    // First Aid / Fire Prevention
    firstAidBox: false,
    accidentRegister: false,
    fireExtinguishersAvailable: false,
    fireExtinguishersCurrent: false,
    fireExtinguishersSufficientNumber: false,
    evacuationProcedureCurrent: false,
    allEmergenciesIncluded: false,
    
    // Remedial Actions
    remedialActions: [],
    
    save: {
        saving: false,
        success: false,
        error: null
    }
};

const addSiteInspectionChecklistFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case fromTypes.ADD_SITE_INSPECTION_CHECKLIST_FORM_VALUE_CHANGE:
            return {
                ...state,
                ...action.payload
            };
            
        case fromTypes.ADD_SITE_INSPECTION_CHECKLIST_FORM_RESET:
            return {
                ...initialState,
                id: uuid.v4()
            };
            
        case fromTypes.ADD_SITE_INSPECTION_CHECKLIST_FORM_SUBMIT:
            return {
                ...state,
                save: {
                    saving: true,
                    success: false,
                    error: null
                }
            };
            
        case fromTypes.ADD_SITE_INSPECTION_CHECKLIST_FORM_SUBMIT_SUCCESS:
            return {
                ...state,
                save: {
                    saving: false,
                    success: true,
                    error: null
                }
            };
            
        case fromTypes.ADD_SITE_INSPECTION_CHECKLIST_FORM_SUBMIT_FAILED:
            return {
                ...state,
                save: {
                    saving: false,
                    success: false,
                    error: action.payload
                }
            };
            
        default:
            return state;
    }
};

export default addSiteInspectionChecklistFormReducer; 